import { createContext } from "react";

export const ToasterContext = createContext(null);